export default __webpack_public_path__ + "static/26-augmented-reality-475f880c87131a53ab1e43a76c1215e4.png";